
  var _styles = {
  "buy-tickets-container": {
    "width": "4.6rem",
    "height": "2.45333rem",
    "borderRadius": "0.48rem"
  },
  "buy-tickets-bg-image": {
    "width": "4.6rem",
    "height": "2.45333rem",
    "borderRadius": "0.48rem"
  },
  "buy-tickets-content": {
    "paddingTop": "0.32rem",
    "paddingRight": "0.42667rem",
    "paddingBottom": "0.24rem",
    "paddingLeft": "0.42667rem",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "buy-tickets-content-title-container": {
    "marginTop": "0.08rem",
    "maxWidth": "3.06667rem",
    "height": "0.32rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "alignItems": "center"
  },
  "buy-tickets-content-title": {
    "width": "1.38667rem",
    "height": "0.64rem",
    "marginRight": "0.10667rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "buy-tickets-content-title-image": {
    "width": "1.38667rem",
    "height": "0.32rem"
  },
  "buy-tickets-title-lunch": {
    "maxWidth": "1.6rem",
    "height": "0.64rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "buy-tickets-title-lunch-text": {
    "fontSize": "0.32rem",
    "fontWeight": "400",
    "lineHeight": "0.64rem"
  },
  "buy-tickets-time": {
    "width": "100%",
    "height": "0.53333rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "marginTop": "0.26667rem"
  },
  "buy-tickets-time-cell": {
    "height": "0.48rem",
    "borderRadius": "0.08rem",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "buy-tickets-button": {
    "width": "2.89333rem",
    "height": "0.64rem",
    "marginTop": "0.16rem",
    "borderRadius": "0.4rem",
    "overflow": "hidden",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "buy-tickets-button-linear": {
    "width": "100%",
    "height": "100%",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "buy-tickets-button-text": {
    "fontSize": "0.32rem",
    "fontWeight": "500",
    "lineHeight": "0.42667rem"
  }
};

  if (typeof FontFace === 'function') {
    
    var fontFace0 = new FontFace('MTNewDigitalDisplay-Bold', 'url("https://s3plus.meituan.net/trip-supplier/mcp-static/MTNewDigitalDisplay-Bold.otf") format("opentype")');
    document.fonts.add(fontFace0);
    
  }
    


  module.exports = _styles;
  